import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('LoanCharacteristics')
export class LoanCharacteristics {
  @JsonProperty('projectId', String, true)
  public id = '';

  @JsonProperty('idTypeParcours', String, true)
  public projectTypeId = '';

  @JsonProperty('indicateurEligibiliteEsign', String, true)
  public isEsignEligible = '';

  @JsonProperty('codeMotifNonEligibiliteEsign', String, true)
  public esignIneligibilityReasonCode = '';

  @JsonProperty('libCodeMotifNonEligibiliteEsign', String, true)
  public esignIneligibilityReasonLabel = '';

  @JsonProperty('indicateurEligibiliteCav', String, true)
  public isCavEligible = '';

  @JsonProperty('codeMotifNonEligibiliteCav', String, true)
  public cavIneligibilityReasonCode = '';

  @JsonProperty('libCodeMotifNonEligibiliteCav', String, true)
  public cavIneligibilityReasonLabel = '';

  @JsonProperty('indicateurEligibiltePoka', String, true)
  public isPokaEligible = '';

  @JsonProperty('codeMotifNonEligibilitePoka', String, true)
  public pokaIneligibilityReasonCode = '';

  @JsonProperty('libCodeMotifNonEligibilitePoka', String, true)
  public pokaIneligibilityReasonLabel = '';

  @JsonProperty('indicateurEligibilitePret', String, true)
  public isLoanEligible = '';

  @JsonProperty('codeMotifNonEligibilitePret', String, true)
  public loanIneligibilityReasonCode = '';

  @JsonProperty('libCodeMotifNonEligibilitePret', String, true)
  public loanIneligibilityReasonLabel = '';

  @JsonProperty('indicateurTypeClient', String, true)
  public customerType = '';
}
